<template>
    <dashboard-layout>

      <template v-if="fetchDataLoading">
        <div class="big-white-card2">
          <center><div class="loader"></div></center>
        </div>
            </template>
            <template v-else>


              <div v-if="!withData">

<div class="center-content2">
  <img class="custom-icon-size" src="@/components/img/Sales_Assests/sales-icon.svg" alt="Custom Icon">
  <p class="write-up">
    No Sales Executive Profiled!
  </p>
  <div class="subhead-text2">Sales Executives are yet to be profiled. After</div>
  <div class="subhead-text2">profiling Sales Executives,they will be listed here.</div>
</div>
</div>
<div v-else>
      <div class="head-text3">Sales Executives</div>
    <div class="subhead-text3">All Profiled Sales Executives will be listed here.</div>
    <div class="big-card">
      <div class="horizontal-container">
   

        <!-- Search bar -->
        <div class="search-bar" style="max-width: 700px;">
        <div class="search-icon ">
          <img src="@/components/img/Sales_Assests/Search.svg" alt="Search Icon" style="padding-right: 10px;">
        </div>
        <input type="text" class="form-control ml-1" v-model="searchTerm"  style="width: 500px; height: 35px; color:#000; font-size: 13px; border: 1px solid #D1D5DB;" placeholder="  Search with Sales Executive ID, Full name...">
      </div>
        </div>
        <hr><hr>


      <div class="custom-table-container" :key="currentPage">
        
      <table class="custom-table">
        <thead>
          <tr>
            <th  style="white-space: nowrap;">Date Created</th>
            <th  style="white-space: nowrap;">Sales Exec ID</th>
            <th  style="white-space: nowrap;">Full Name</th>
            <th  style="white-space: nowrap;">Merchants</th>
            <th  style="white-space: nowrap;">Transaction Volume</th>
            <th  style="white-space: nowrap;">Transaction Value</th>
            <th></th> 
          </tr>
        </thead>
        <tbody>
          <template v-if="filteredRows.length === 0">
        <tr>
          <td colspan="7" style="text-align: center;">No records found</td>
        </tr>
      </template>
          <template v-else-if="searchTerm && filteredRows.length > 0">
          <tr v-for="(row, index) in filteredRows" :key="index" class="table-row" @click="navigateToDetails(row)">
            <td>{{ formatDate(row.CreatedAt) }}</td>
            <td>{{ row.UserId }}</td>
            <td style="white-space: nowrap;">{{ row.FirstName }} {{ row.LastName }}</td>
            <td>{{ row.businessOwnersCount }}</td>
            <td>{{ row.totalVolumeCount }}</td>
            <td>₦{{ row.totalValueCount }}</td>
            <td class="vertical-dots-cell">
              <!-- Vertically aligned dots -->
              <img src="@/components/img/Sales_Assests/dots.svg" 
                   alt="View Icon" 
                   style="padding-right: 10px;"
                   @click.stop="togglePopup(row)">

              <!-- Popup tab -->
              <div class="popup-tab2" v-show="row.showPopup">
                <router-link v-if="row.UserId" :to="{ path: '/administrative/sales-execs/details', query: { SEID: row.UserId } }" class="popup-item nav-link">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  View User Details
                </router-link>
              </div>
            </td>
          </tr>
          </template>
          <template v-else>
           <tr v-for="(row, index) in visibleRows" :key="index" class="table-row" @click="navigateToDetails(row)">
            <td>{{ formatDate(row.CreatedAt)}}</td>
            <td>{{ row.UserId }}</td>
            <td style="white-space: nowrap;">{{ row.FirstName }} {{ row.LastName }}</td>
            <td>{{ row.businessOwnersCount }}</td>
            <td>{{ row.totalVolumeCount }}</td>
            <td>₦{{ formatAmount(row.totalValueCount) }}</td>
            <td class="vertical-dots-cell">
              <!-- Vertically aligned dots -->
              <img src="@/components/img/Sales_Assests/dots.svg" 
                   alt="View Icon" 
                   style="padding-right: 10px;"
                   @click.stop="togglePopup(row)">

              <!-- Popup tab -->
              <div class="popup-tab2" v-show="row.showPopup">
                <router-link v-if="row.UserId" :to="{ path: '/administrative/sales-execs/details', query: { SEID: row.UserId } }" class="popup-item nav-link">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  View User Details
                </router-link>
              </div>
            </td>
          </tr>
        </template>

        </tbody>
      </table>
      <div class="pagination">
      <span>{{ currentPageStart }} - {{ currentPageEnd }} of {{ totalRows }}</span>
      <img src="@/components/img/Sales_Assests/previousbutton.svg" 
      class="pagination-icon1"
      alt="Prev Icon" 
      @click="prevPage">
      <img src="@/components/img/Sales_Assests/nextbutton.svg" 
      class="pagination-icon2"
      alt="Next Icon" 
      @click="nextPage">
    </div>
    <hr>
    </div>
      </div>
      </div>

  </template>




    </dashboard-layout>
  </template>
  
  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  import axios from 'axios'; 
  
  export default {
    name: 'sales-execs',
  
    components: {
      DashboardLayout,

    },
  
    data() {
    return {

      showContinueModal: false,
      selectedRowData: {},
      fetchDataLoading: true,
      currentPage: 1,
      rowsPerPage: 10,
      totalRows: 0,
      searchTerm: '',


      hovered: false,
      showOnboardingModal0: false,
      onboardButtonClicked: false,
      businessType: '',
      businessName: '',
      email: '',
      taxNumber: '',
      phoneNumber: '',
      userID: '',
      withData: false,
      isDropdownOpen: false,
      cardSwitch: 'Onboarded',
      tableData: [],
      onboardedData: [],
      pendingData:[],
      showPopup: Array(3).fill(false),
      
    };
  },

  async mounted() {
    this.userID = sessionStorage.getItem('userId');
    document.addEventListener('click', this.closePopups);

    try{
      await this.fetchAllSalesExecutives();
      this.totalRows = this.tableData.length;
      if(this.tableData.length > 0){
        this.withData = true;
        
      }
      this.fetchDataLoading = false;
    }catch(error){
      console.log(error);
    }
  
  },

  computed: {

filteredRows() {
let filteredData = [];
let startIndex = 0;
let endIndex = 0;
const term = this.searchTerm.toLowerCase().trim();
if (!term) return this.tableData;

// Filter rows based on search term
filteredData = this.tableData.filter(row =>
  Object.values(row).some(value =>
    value && value.toString().toLowerCase().includes(term)
  )
);

// Apply pagination to filtered rows
startIndex = (this.currentPage - 1) * this.rowsPerPage;
endIndex = startIndex + this.rowsPerPage;

return filteredData.slice(startIndex, endIndex);
},


visibleRows() {
const startIndex = (this.currentPage - 1) * this.rowsPerPage;
const endIndex = startIndex + this.rowsPerPage;

// Filter rows based on search term
const filteredRows = this.filteredRows;

// Slice the filtered rows based on pagination
return filteredRows.slice(startIndex, endIndex);
},
currentPageStart() {
if (this.searchTerm) {
  return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.filteredRows.length);
} else {
  return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.totalRows);
}
},

currentPageEnd() {
if (this.searchTerm) {
  return Math.min(this.currentPage * this.rowsPerPage, this.filteredRows.length);
} else {
  return Math.min(this.currentPage * this.rowsPerPage, this.totalRows);
}
}


},

  methods: {

    navigateToDetails(row) {
    if (row.UserId) {
      sessionStorage.setItem('SalesUserId', row.UserId);
      this.$router.push({
        path: '/administrative/sales-execs/details',
        query: { SEID: row.UserId }
      });
    }
  },

    formatAmount(amount) {
  const parsedAmount = parseFloat(amount);

 
  if (isNaN(parsedAmount)) {
    console.error('Invalid amount:', amount);
    return ''; 
  }


  const roundedAmount = parsedAmount.toFixed(2);

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true 
  });

  return formatter.format(roundedAmount);
},


    async fetchAllSalesExecutives() { 
    try {
        // Fetch data from the first endpoint
        const firstResponse = await axios.get(this.$config.GETUSERS_ENDPOINT);
        
        // Filter out the users with the role "Sales Executive"
        const salesExecutives = firstResponse.data.filter(user => user.Role === 'Sales Executive');
        
        // Extract user IDs
        // const userIds = salesExecutives.map(user => user.UserId);

        // Fetch data from the second endpoint
        const secondResponse = await axios.get(this.$config.SALEEXEUTIVEDATA_ENDPOINT);
        
        // Map data from the second response to the sales executives
        this.tableData = salesExecutives.map(salesExec => {
            const salesExecutiveReport = secondResponse.data.data.salesExecutivesReport.find(report => report.salesExecutiveId == salesExec.UserId);
            return {
                ...salesExec,
                businessOwnersCount: salesExecutiveReport ? salesExecutiveReport.businessOwnersCount : 0,
                totalVolumeCount: salesExecutiveReport ? salesExecutiveReport.totalVolumeCount : 0,
                totalValueCount: salesExecutiveReport ? salesExecutiveReport.totalValueCount : 0
            };
        });

        console.log('Onboarded Data:', this.tableData);
    } catch (error) {
        console.error('Error fetching onboarded merchants:', error);
    }
},



    openContinueModal(rowData) {
      this.selectedRowData = rowData; 
      this.showContinueModal = true;
    },
    async closeContinueModal() {
      this.fetchPendingOnboard()
      this.showContinueModal = false;
    },

    formatDate(dateTimeString) {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits for day
    const month = date.toLocaleString('en-US', { month: 'short' }); // Get short month name
    const year = date.getFullYear().toString(); // Get full year

    // Concatenate day, month, and year with hyphens
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
},

    async fetchPendingOnboard() {
      const token = sessionStorage.getItem('token');
    try {
      const response = await axios.get(`${this.$config.GETPENDINGONBOARD_ENDPOINT}/${this.userID}`,
      {
        headers: {
          Authorization: `Bearer ${token}` 
        }
      });
     
      this.pendingData = response.data.onboardingData;
      console.log('Value is',  this.pendingData);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  },

    handleCardSwitch() {
     if(this.cardSwitch == 'Onboarded'){
       this.tableData = this.onboardedData;
       this.totalRows = this.tableData.length;
     } else if(this.cardSwitch == 'Pending'){
      this.tableData = this.pendingData;
      this.totalRows = this.tableData.length;
     }
    },

    nextPage() {
    const totalPages = Math.ceil(this.totalRows / this.rowsPerPage);
    if (this.currentPage < totalPages) {
      this.currentPage++;
    }
  },
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  },



    toggleHover() {
            this.hovered = !this.hovered;
          
        },

        togglePopup(row) {
          this.tableData.forEach(row => {
        row.showPopup = false;
      });
          console.log('popup clicked', row);
    // Check if the row already has the showPopup property
    if (!Object.prototype.hasOwnProperty.call(row, 'showPopup')) {
      // If not, add it with an initial value of false
      this.$set(row, 'showPopup', false);
    }
    // Toggle the showPopup value for the corresponding row
    row.showPopup = !row.showPopup;
  },


    closePopups() {

      console.log('Close popup clicked');
      // Close all popups
      this.tableData.forEach(row => {
        row.showPopup = false;
      });
    },

   

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        this.$refs.dropdown.focus();
      }
    },

    closeOnboardingModal0() {
      this.showOnboardingModal0 = false;
    },

    closeOnboardingModal1() {
      this.onboardButtonClicked = false;
    },

    openOnboardingModal1() {
      this.onboardButtonClicked = true;
    },

    openOnboardingModal0() {
      this.showOnboardingModal0 = true;
      this.onboardButtonClicked = true;
     
    },
   
  },
  
  };
  </script>
  
  <style>

.loader {
  width: auto;
  height: 30px;
  margin-top: 220px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 3px solid #6F48FF;
  animation:
    l20-1 0.8s infinite linear alternate,
    l20-2 1.6s infinite linear;
}
@keyframes l20-1{
   0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
   12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
   25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
   50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
   100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}
@keyframes l20-2{ 
  0%    {transform:scaleY(1)  rotate(0deg)}
  49.99%{transform:scaleY(1)  rotate(135deg)}
  50%   {transform:scaleY(-1) rotate(0deg)}
  100%  {transform:scaleY(-1) rotate(-135deg)}
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 40px;
  font-weight: bold;
  font-size: 13px;
  color: #000;
}

.pagination-icon1 {
  cursor: pointer;
  margin-left: 10px;
  transition: transform 0.3s;
}

.pagination-icon1:hover{
  background-color: #ddd1e8;
  transform: scale(1.1);
}

.pagination-icon2 {
  cursor: pointer;
  transition: transform 0.3s;
}

.pagination-icon2:hover{
  background-color: #ddd1e8;
  transform: scale(1.1);
}

.popup-item {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
}

.popup-item:hover {
    color: #6F48FF; /* Change font color on hover */
}

.popup-icon {
    margin-right: 5px;
    transition: filter 0.3s; /* Add transition effect */
}

  .divider{
    height: 0.5px;
    background-color: #F1F3F9;
    width: auto;
    margin-top: 3px;
    margin-bottom: 3px;
  }

.vertical-dots-cell {
  position: relative;
}

.vertical-dots {
  width: 20px;
  height: 20px;
  background-color: #ccc;
  border-radius: 50%;
  cursor: pointer;
}

.popup-tab2 {
    position: absolute;
    top: -10px; 
    right: 2%;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 999; 
    width: 165px;
    font-size: 12px;
}

.popup-item:hover .popup-icon {
    filter: invert(43%) sepia(11%) saturate(5412%) hue-rotate(218deg) brightness(99%) contrast(100%); /* Change icon color on hover */
}



/* Styling for table rows */
.custom-table tbody tr:hover {
  background-color: #F7F5FF; 
}

.custom-table-container {
  overflow-y: auto; 
  overflow-x: auto; 
}


.custom-table {
  border-collapse: collapse;
  width: 100%;
}

.custom-table th,
.custom-table td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #fff;
  font-size: 14px;
}

.custom-table th {
  background-color: #fff;
  border-top: 1px solid #F5EDFC;
  font-size: 15px;
}


.custom-table th,
.custom-table td {
  border-bottom: 1px;
}

/* Styling for horizontal lines */
.custom-table th,
.custom-table tbody tr {
  border-bottom: 1px solid #ddd1e8;
  color: #000;
}

/* Remove border from last row */
.custom-table tbody tr:last-child {
  border-bottom: 1px solid #ddd1e8;
}


.onboard-button2 {
  background-color: #6F48FF;
  color: #FFF;
  border: none;
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  width: 200px;
  height: 35px;
}

.horizontal-container {
  display: flex;
  padding: 0px;
 
}


.big-card  {
    background-color: #FFF; 
    margin: 20px 40px; 
    padding: 20px; 
    max-height: 800px;
  }

  


.search-bar {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 10px; 
  top: 50%;
  transform: translateY(-50%);
  z-index: 1; 
}

.search-icon i {
  color: #ccc; 
  cursor: pointer;
}

.search-bar input[type="text"] {
  padding-left: 30px; 
}


/* Styling for button container */
.button-container {
  display: flex;
  justify-content: flex-end;
}

.extreme-right-button {
  background-color: #6F48FF;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}



.onboard-button {
  background-color: #6F48FF;
  color: #FFF;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  margin-top: 20px;
  width: 270px;
  height: 40px;
}
  
  
  </style>
  